import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './ClientLogin.css';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      return setError('Password must be at least 8 characters');
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
      return setError('Password must contain at least one uppercase letter, one lowercase letter, and one number');
    }
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }

    setLoading(true);
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

    try {
      await axios.post(`${API_URL}/auth/reset-password/${token}`, { password });
      setSuccess(true);
      setTimeout(() => navigate('/client/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid or expired reset link');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="client-login-page">
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <h1>Password Reset Successful</h1>
              <p>You can now log in with your new password</p>
            </div>
            <div style={{textAlign:'center',color:'#059669',padding:'2rem 0'}}>
              ✓ Redirecting to login...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Reset Your Password</h1>
            <p>Enter your new password below</p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Min 8 chars, upper + lower + number"
                autoComplete="new-password"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Re-enter password"
                autoComplete="new-password"
                required
              />
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>

          <div style={{textAlign:'center',marginTop:'1.5rem'}}>
            <Link to="/client/login" style={{color:'#6b7280',fontSize:'0.9rem',textDecoration:'none'}}>
              ← Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
